import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { MyPlace } from "@/features/my/places";

export const Route = createFileRoute("/(member)/(protected)/my/places/")({
  component: MyPlace,
  validateSearch: z.object({
    planKey: z.string().optional(),
    discountCode: z.string().optional(),
    checkoutId: z.string().optional(),
    addOns: commaListSchema,
    referId: z.string().optional(),
    referredBy: z.string().optional(),
  }),
});
